import React from "react";
import { Button, Typography, Tag } from "antd";
import { StarFilled } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import {
  StaffCard,
  ImageContainer,
  CoverImage,
  RatingBadge,
  ContentContainer,
  InfoSection,
  PriceSection,
} from "./Staff.styles";
import type { TopStaffDTO } from "../../hooks/useTopStaff";

export interface StaffProps {
  staff: TopStaffDTO;
}

const Staff: React.FC<StaffProps> = ({ staff }) => {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <StaffCard $isHovered={isHovered} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      <ImageContainer>
        <CoverImage $isHovered={isHovered} src={staff.coverImageUrl} alt="professional" />
        <RatingBadge>
          <StarFilled style={{ color: "#fadb14", fontSize: 12 }} />
          <Typography.Text strong style={{ fontSize: 12 }}>
            4.9
          </Typography.Text>
        </RatingBadge>
      </ImageContainer>

      <ContentContainer>
        <InfoSection>
          <Tag color="purple" style={{ marginBottom: 8, fontSize: 10, fontWeight: 600 }}>
            {staff.location}
          </Tag>
          <Typography.Title level={5} style={{ marginBottom: 4 }}>
            {staff.name}
          </Typography.Title>
          <Typography.Text type="secondary" style={{ fontSize: 13 }}>
            120 {t("home.specialists.reviews")}
          </Typography.Text>
        </InfoSection>

        <PriceSection>
          <Typography.Text strong style={{ fontSize: 16 }}>
            {t("home.specialists.from")} $50
          </Typography.Text>
          <Button type="primary" size="middle">
            {t("home.specialists.book")}
          </Button>
        </PriceSection>
      </ContentContainer>
    </StaffCard>
  );
};

export default Staff;
